module.exports = __webpack_public_path__ + "img/israel_yes.16c45fa9.png";